import { Drawer } from 'components/Drawer'
import { observer } from 'mobx-react-lite'
import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { IObservableArray } from 'mobx'
import { useRef, useState, useEffect, useCallback } from 'react'
import Styles from './ImageReviewDrawer.module.scss'
import { Button } from 'blaze-ui/Button'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { ArrowRight, Close } from 'blaze-ui/icons'
import Masonry from 'react-masonry-css'

interface ImageReviewDrawerProps {
  selectedFiles: IObservableArray<IMediaFile>
  onClose: () => void
  onSubmit: () => void
  submitLabel?: string
}

export const ImageReviewDrawer = observer((props: ImageReviewDrawerProps) => {
  const { onClose, onSubmit, selectedFiles, submitLabel = 'Confirm Images' } = props

  const bodyRef = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(true)

  const handleRemove = (file: IMediaFile) => {
    const index = selectedFiles.findIndex((f) => f.id === file.id)
    if (index !== -1) {
      selectedFiles.splice(index, 1)
    }
  }

  const handleClose = useCallback(() => {
    setIsOpen(false)
    onClose()
  }, [onClose])

  useEffect(() => {
    if (selectedFiles.length === 0) {
      handleClose()
    }
  }, [selectedFiles.length, handleClose])

  return (
    <Drawer.Root onOpenChange={handleClose} open={isOpen} key="image-review-drawer">
      <Drawer.Portal>
        <Drawer.Content fullHeight>
          <div style={{ height: '100%' }} data-vaul-no-drag>
            <Drawer.InnerContent isSnappedTop>
              <Drawer.Top>
                <Drawer.Back variant="editor" onPress={handleClose} />
                <Drawer.Title asChild>
                  <span className={Styles.drawerTitle}>Review Images</span>
                </Drawer.Title>
                <div />
              </Drawer.Top>

              <Drawer.Container padding="0px 16px 72px" ref={bodyRef}>
                <Masonry
                  breakpointCols={{
                    default: 2,
                  }}
                  className={Styles.grid}
                  columnClassName={Styles.column}
                  data-testid="image-review-grid"
                >
                  {selectedFiles.map((file) => (
                    <div key={file.id} className={Styles.cell}>
                      <img src={file.source_url} alt={''} />
                      <IconButton
                        className={Styles.removeButton}
                        onPress={() => handleRemove(file)}
                        aria-label="Remove image"
                        title="Remove image"
                        icon={() => <Close size={16} />}
                        variant="tertiary"
                        size="xs"
                      />
                    </div>
                  ))}
                </Masonry>
              </Drawer.Container>
              {onSubmit && (
                <div className={Styles.submitButtonContainer}>
                  <Button
                    variant="primary"
                    size="lg"
                    onPress={onSubmit}
                    endIcon={ArrowRight}
                    fullWidth
                    data-testid="submit-button"
                  >
                    {submitLabel}
                  </Button>
                </div>
              )}
            </Drawer.InnerContent>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
})
